import PocketBase from 'pocketbase';

// Utilisation des variables d'environnement avec une valeur par défaut
const POCKETBASE_URL = process.env.REACT_APP_POCKETBASE_URL;

if (!POCKETBASE_URL) {
  console.error('REACT_APP_POCKETBASE_URL n\'est pas définie dans les variables d\'environnement');
}

export const pb = new PocketBase(POCKETBASE_URL);

